import type { Action, StoreActionApi } from '@atlassian/react-sweet-state';
import type { State, ColumnMap, MappingState } from '../../../../common/types';
import { makeColumnVisible } from '../../../../common/utils';

export type SetIsVisibleForAllAction = (isVisible: boolean) => Action<State, void, void>;

const hideAllColumns = (mappingState: MappingState): MappingState => {
	const newColumnState: ColumnMap = {};
	mappingState.columnOrder.forEach((colName) => {
		newColumnState[colName] = {
			...mappingState.columns[colName],
			isVisible: false,
		};
	});

	return {
		...mappingState,
		columns: newColumnState,
		mappedJiraFieldIds: new Set(),
		validationError: null,
	};
};

const showAllColumns = (mappingState: MappingState): MappingState => {
	let updatedMappingState = mappingState;

	mappingState.columnOrder.forEach((colName) => {
		if (!updatedMappingState.columns[colName].isVisible) {
			updatedMappingState = makeColumnVisible(updatedMappingState, colName);
		}
	});

	return updatedMappingState;
};

export const setIsVisibleForAll =
	(isVisible: boolean) =>
	({ setState, getState }: StoreActionApi<State>) => {
		const state = getState();
		if (state.mappingState === null) {
			return;
		}

		const updatedMappingState = isVisible
			? showAllColumns(state.mappingState)
			: hideAllColumns(state.mappingState);

		setState({
			mappingState: updatedMappingState,
		});
	};
